<template>
    <div>
        <element-wrapper @click="open" icon="fas fa-tag has-text-grey-light" ref="instance">
            <span>
                {{tag.name}}

                <span class="badge" :style="{backgroundColor: tag.color}">
                    {{ tag.notes_count || 0 }}
                </span>
            </span>

            <template slot="dropdown">
                <a v-if="space_permission('TAG_UPDATE')"
                   @click.stop="show_edit = true"
                   class="dropdown-item">

                    <i class="icon fas fa-pen"></i> Edit
                </a>

                <a v-if="space_permission('TAG_DELETE')"
                   @click.stop="show_confirm = true"
                   class="dropdown-item">
                    <i class="icon fas fa-trash-alt"></i> Delete
                </a>
            </template>

            <base-confirm-modal
                v-if="show_confirm"
                text="Do you really want to remove this Tag?"
                @close="show_confirm = false"
                @ok="remove"/>

        </element-wrapper>

        <tag-update-modal
            v-if="show_edit"
            :space="space"
            :tag="tag"
            @close="show_edit = false"/>
    </div>
</template>

<script>
import TagUpdateModal from './TagUpdateModal.vue';
import ElementWrapper from '../common/ElementWrapper.vue';

export default {
    name: 'TagItem',
    props: ['space', 'tag'],
    components: { TagUpdateModal, ElementWrapper },
    data() {
        return { show_confirm: false, show_edit: false };
    },
    methods: {
        open() {
            this.$router.push({ name: 'content', query: { tags: this.tag.id } });
        },
        remove() {
            this.$store.dispatch('tags/remove', { space_id: this.space.id, tag_id: this.tag.id });
        },
    },
};
</script>

<style scoped>
    .badge {
        background: #d0d0d0;
        padding: 0.08rem 0.4rem;
        border-radius: 4px;
        color: #fff;
        font-size: 0.5em;
    }
</style>
